export default ({ searchUrl = '/search', blogPath = '', buttonLabel = 'Read more' } = {}) => ({
    searchUrl,
    blogPath,
    buttonLabel: buttonLabel || 'Read more',
    query: '',
    status: '',
    defaultGridHtml: '',
    defaultPaginationHtml: '',
    activeController: null,
  
    get hasQuery() {
      return this.query.trim().length > 0;
    },
  
    init() {
      this.defaultGridHtml = this.$refs.grid ? this.$refs.grid.innerHTML : '';
      this.defaultPaginationHtml = this.$refs.pagination ? this.$refs.pagination.innerHTML : '';
    
      this.applyButtonLabel();
    },
  
    handleInput() {
      const query = this.query.trim();
  
      if (!query.length) {
        this.resetGrid();
        return;
      }
  
      if (query.length < 2) {
        this.status = '';
        return;
      }
  
      this.fetchResults(query);
    },
  
    submitSearch() {
      const query = this.query.trim();
  
      if (!query.length) {
        this.resetGrid();
        return;
      }
  
      if (query.length < 2) {
        this.status = 'Type at least 2 characters.';
        return;
      }
  
      this.fetchResults(query);
    },

    applyButtonLabel(root = this.$refs.grid) {
      if (!root || !this.buttonLabel) return;
    
      root.querySelectorAll('[data-article-card-button-label]').forEach((label) => {
        label.textContent = this.buttonLabel;
      });
    },
  
    clearSearch() {
      this.query = '';
      this.resetGrid();
  
      this.$nextTick(() => {
        if (this.$refs.input) {
          this.$refs.input.focus();
        }
      });
    },
  
    resetGrid() {
        if (this.activeController) {
            this.activeController.abort();
            this.activeController = null;
        }

        if (!this.$refs.grid) {
            this.status = '';
            return;
        }

        this.$refs.grid.innerHTML = this.defaultGridHtml;

        if (this.$refs.pagination) {
            this.$refs.pagination.innerHTML = this.defaultPaginationHtml;
        }

        this.status = '';
        this.initInjectedAlpine();
    },
  
    fetchResults(query) {
      if (this.activeController) {
        this.activeController.abort();
      }
  
      this.activeController = new AbortController();
  
      const url = new URL(this.searchUrl, window.location.origin);
  
      url.searchParams.set('view', 'blog-ajax');
      url.searchParams.set('type', 'article');
      url.searchParams.set('options[prefix]', 'last');
      url.searchParams.set('q', query);
  
      this.status = `Searching for “${query}”...`;
  
      fetch(url.toString(), {
        signal: this.activeController.signal,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Search request failed');
          }
  
          return response.text();
        })
        .then((html) => {
          if (query !== this.query.trim()) return;
  
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const results = doc.querySelector('[data-blog-search-results]');
          const resultGrid = results ? results.querySelector('[data-blog-search-grid]') : null;
  
          if (!results || !resultGrid) {
            this.renderEmptyState(query);
            return;
          }
  
          const cards = Array.from(resultGrid.querySelectorAll('[data-blog-result-card]'));
  
          cards.forEach((card) => {
            const articleUrl = card.dataset.articleUrl || '';
  
            if (this.blogPath && articleUrl.indexOf(this.blogPath) === -1) {
              card.remove();
            }
          });
  
          const remainingCards = resultGrid.querySelectorAll('[data-blog-result-card]');
  
          if (!remainingCards.length) {
            this.renderEmptyState(query);
            return;
          }
  
          if (this.$refs.grid) {
            this.$refs.grid.innerHTML = resultGrid.innerHTML;
            this.applyButtonLabel();
          }
  
          if (this.$refs.pagination) {
            this.$refs.pagination.innerHTML = '';
          }
  
          this.status = `Showing ${remainingCards.length} result${
            remainingCards.length === 1 ? '' : 's'
          } for “${query}”.`;
  
          this.initInjectedAlpine();
        })
        .catch((error) => {
          if (error.name === 'AbortError') return;
  
          this.status = 'Search failed. Please try again.';
        });
    },
  
    renderEmptyState(query) {
      if (!this.$refs.grid) return;
  
      this.$refs.grid.innerHTML = `
        <div class="rounded-3xl bg-linen p-6 text-center text-mahogany md:col-span-2 lg:col-span-3">
          <p class="m-0 text-base font-bold">
            No articles found for “${this.escapeHtml(query)}”.
          </p>
        </div>
      `;
  
      if (this.$refs.pagination) {
        this.$refs.pagination.innerHTML = '';
      }
  
      this.status = '';
    },
  
    escapeHtml(value) {
      const div = document.createElement('div');
      div.textContent = value;
      return div.innerHTML;
    },
  
    initInjectedAlpine() {
      this.$nextTick(() => {
        if (
          window.Alpine &&
          typeof window.Alpine.initTree === 'function' &&
          this.$refs.grid
        ) {
          window.Alpine.initTree(this.$refs.grid);
        }
      });
    },
  });